export enum TrackingEvent {
  TextSearch = `[mp-filter-bar-table] Text Search`,
}

export enum TrackingEventProperty {
  SearchQuery = `Search query`,
  TrackName = `name`,
}

type TrackingEventProperties = {
  [key in TrackingEventProperty]?: any;
};

export function track(event: TrackingEvent, properties: TrackingEventProperties) {
  mixpanel.track(event, properties);
}
